import React,{Component} from 'react';
import Head from './Head'
import Foot from './Foot'
import Grid from 'material-ui/Grid';
import Paper from 'material-ui/Paper';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';
import Button from 'material-ui/Button';
import { withStyles, MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import Label from './Label'
import { getJSON } from 'jquery'
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Divider from 'material-ui/Divider';
import Cookies from 'js-cookie'
import ExpansionPanel, {
    ExpansionPanelSummary,
    ExpansionPanelDetails,
} from 'material-ui/ExpansionPanel';



class WriteBlog extends Component{
    saveBlog(){
        Cookies.set('blog',draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())));
    }





constructor(props){


    var blog= Cookies.get('blog');
    var editorState=EditorState.createEmpty();
    if (blog!=null) {
        const contentBlock = htmlToDraft(blog);
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
         editorState = EditorState.createWithContent(contentState);
    }

    super(props);
    this.state={
        load:false,
        editorState:editorState,
        submitError:false,
        title:'',
        type:'',
        label:'',
        signal:'',
        context:''
    }

    setInterval(this.saveBlog.bind(this),3000);

}






    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: event.target.value});
        console.log(this.state)
    }

    handleSubmit(){
        const {title,signal,type,label}=this.state;
        if (title!=''&&signal!=''&&type!=''&&label!='') {
            this.setState({
                load: true
            })
            const context = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()));

            const form = new FormData();
            form.append('title', title);
            form.append('signal', signal);
            form.append('type', type);
            form.append('context', context);
            form.append('label', label);
            const url = 'http://123.207.90.121:8080/newBlog/api/addBlog';
            return fetch(url, {
                body:form,
                method: 'POST'
            })
                .then(function(response) {
                    return response.json();
                })
                .then(response => {
                    console.log("sadsdasad"+response)
                    return
                    true
                }).then((flash) => this.props.handleBlogRoute())
                .catch(error => console.error('Error:', error))

        }
    }
    handleSubmitError(){
        this.setState({SubmitError:!this.state.SubmitError})
        this.setState({
            load:false
        })

    }


    onEditorStateChange=(editorState)=> {
        this.setState({
            editorState:editorState
        });
    };






    render(){

        const theme = createMuiTheme({
            palette: {
                primary: green,
            },
        });


        return(
            <div id="cc" style={{height:'100%',overflow: 'auto'}}>
                <Head src='image/blogHeader.jpg' title='Write BLOG' sentence='Connect your nerver To the system of Philosophiofantasia' />
                <div style={{backgroundImage:'url(\'image/pageBackground.jpg\')',backgroundColor:'white',backgroundSize:'cover',padding:'50px 5% 50px',
                    backgroundPositionX:'center',
                    backgroundPositionY: 'top',
                    boxShadow: '0px 10px 10px 10px  #888888 inset',minHeight:'100%'
                }}>


                    <Grid  container spacing={24}style={{display:'flex',
                        flexDirection:'row-reverse',
                        flexWrap:'warp',
                        justifyContent:'flex-start'}}>


                        <Grid item xs={12} sm={12} md={3}>
                            <Grid container spacing={24} style={{display:'flex',
                                flexDirection:'column',
                                flexWrap:'warp',
                                justifyContent:'flex-start'}}>


                                <Grid item xs={12} sm={12} md={12}>
                                    <Label/>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>


                                    <div style={{marginBottom:'20px'}}>
                                        <ExpansionPanel style={{background: 'white'}}>
                                            <ExpansionPanelSummary expandIcon={
                                                <Button style={{backgroundColor:'#fffdf4',height:'30px',width:'37px'}} variant="fab" aria-label="edit" >
                                                    <i className="material-icons">compare_arrows</i>
                                                </Button>}>
                                                <img src='image/novel/d1.jpg' height={'100px'}/>
                                                <p style={{marginLeft:'10px'}}>
                                                    HTML SHOW
                                                </p>

                                            </ExpansionPanelSummary>
                                            <ExpansionPanelDetails>
                                                <Divider/>

                                                <textarea rows={30}  style={{minWidth:'100%',overflow:'scroll'}}
                                                    disabled
                                                    value={draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))}
                                                />


                                            </ExpansionPanelDetails>
                                        </ExpansionPanel>

                                    </div>



                                </Grid>
                            </Grid>
                        </Grid>




                        <Grid item xs={12} sm={12} md={8}>

                                <Paper style={{height:'100%',width:'100%'}}>



                                    <MuiThemeProvider theme={theme}>
                                        <div style={{textAlign:'Center',overflow:'hidden'}}>
                                            <h1 style={{color:'black'}}><b>WRITE BLOG FROM</b></h1>
                                        </div>
                                        <Grid container spacing={24} >
                                        <Grid item xs={12} sm={12} md={6} style={{textAlign:'center'}}>
                                                <FormControl>
                                                    <InputLabel htmlFor="title" >TITLE</InputLabel>
                                                    <Input type='text'
                                                           id="title"  onChange={this.handleChange.bind(this)} name="title"
                                                           startAdornment={
                                                               <InputAdornment position="start">
                                                                   <i className="material-icons">subtitles</i>
                                                               </InputAdornment>
                                                           }
                                                    />
                                                </FormControl>
                                        </Grid>

                                            <Grid item xs={12} sm={12} md={6} style={{textAlign:'center'}}>
                                                <FormControl>
                                                    <InputLabel htmlFor="label" >LABEL</InputLabel>
                                                    <Input type='text' name="label"
                                                           id="label" onChange={this.handleChange.bind(this)}
                                                           startAdornment={
                                                               <InputAdornment position="start">
                                                                   <i className="material-icons">merge_type</i>
                                                               </InputAdornment>
                                                           }
                                                    />
                                                </FormControl>
                                            </Grid>



                                        <Grid item xs={12} sm={12} md={6} style={{textAlign:'center'}}>
                                            <FormControl >
                                                <InputLabel htmlFor="type">TYPE</InputLabel>
                                                <Select
                                                    value={this.state.type}
                                                    onChange={this.handleChange.bind(this)}
                                                    inputProps={{
                                                        name: 'type',
                                                        id: 'type',
                                                    }}
                                                >
                                                    <MenuItem value={'java'}>JAVA</MenuItem>
                                                    <MenuItem value={'js'}>JS</MenuItem>
                                                    <MenuItem value={'sql'}>SQL</MenuItem>
                                                    <MenuItem value={'else'}>ELSE</MenuItem>
                                                    <MenuItem value={'life'}>LIFE</MenuItem>
                                                    <MenuItem value={'project'}>PROJECT</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>


                                        <Grid item xs={12} sm={12} md={6} style={{textAlign:'center'}}>
                                                <FormControl>
                                                    <InputLabel htmlFor="label" >SINGAL</InputLabel>
                                                    <Input type='text' name="signal"
                                                           id="label" onChange={this.handleChange.bind(this)}
                                                           startAdornment={
                                                               <InputAdornment position="start">
                                                                   <i className="material-icons">signal_cellular_null</i>
                                                               </InputAdornment>
                                                           }
                                                    />
                                                </FormControl>
                                        </Grid>




                                            <Grid item xs={12} sm={12} md={12} style={{textAlign:'center'}}>
                                                <Grid container style={{textAlign:'center'}}>
                                                    <Grid item  sm={1} />
                                                    <Grid item xs={12} sm={10}  style={{textAlign:'center'}}>
                                            <div>
                                                <Editor
                                                    toolbar={{

                                                        image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } },
                                                    }}
                                                    editorState={this.state.editorState}
                                                    wrapperClassName="demo-wrapper"
                                                    editorClassName="demo-editor"
                                                    onEditorStateChange={this.onEditorStateChange}

                                                        localization={{
                                                            locale: 'zh',
                                                        }}
                                                />



                                            </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>


                                            <Grid item xs={12} sm={12} md={12} style={{textAlign:'center',marginTop:'20px',marginBottom:'20px'}}>

                                                <FormControl>

                                                    {this.state.load?
                                                        <Button size="large" style={{backgroundColor:'#ac2d27'}}  >
                                                            Loading
                                                        </Button>
                                                        :
                                                        <Button size="large" style={{backgroundColor:'#5ac73e'}} onClick={this.handleSubmit.bind(this)} >
                                                            SUBMIT
                                                        </Button>
                                                    }

                                                </FormControl>

                                            </Grid>




                                        </Grid>
                                    </MuiThemeProvider>
                                </Paper>




                        </Grid>




                    </Grid>




                </div>
                <Foot src='image/blogFooter.jpg'  sentence='It seems that a generation has passed.' info='© 2018 By Kayer'  />
            </div>
        )
    }







    uploadImageCallBack(file) {
        const form = new FormData();
        form.append('image', file);
        //123.207.90.121
        const url = 'http://123.207.90.121:8080/newBlog/files/upload';
        return fetch(url, {
            body:form,
            method: 'POST'
        })
            .then(function(response) {
                return response.json();
            })
            .then(response => {
                return {
                    data: {
                        link:response.data
                    }
                }
            })
            .catch(error => console.error('Error:', error))
    }






}
export default WriteBlog;


// WEBPACK FOOTER //
// ./src/Compent/page/WriteBlog.js